import React from "react";
import NavLight from "components/Nav/NavLight";
import Footer from "components/Footer";
// No import of old Features component

const features = [
  {
    icon: "mdi-account-group",
    title: "Unified CRM",
    desc: "Manage leads, customers, and communication in one place. Build lasting relationships with a complete customer profile and history.",
    color: "#4f8cff",
  },
  {
    icon: "mdi-file-document-edit",
    title: "Quote to Delivery",
    desc: "Seamlessly create quotes, convert to work orders, and track every step until delivery. Reduce errors and speed up your workflow.",
    color: "#00c9a7",
  },
  {
    icon: "mdi-factory",
    title: "Production Control",
    desc: "Monitor production, manage inventory, and analyze efficiency with real-time dashboards and reports.",
    color: "#ffb300",
  },
  {
    icon: "mdi-package-variant-closed",
    title: "Inventory Management",
    desc: "Track material stock, purchase orders, and vendor relationships. Stay audit-ready with detailed logs and exports.",
    color: "#ff5c93",
  },
  {
    icon: "mdi-shield-lock",
    title: "Security & Permissions",
    desc: "Role-based access, secure password management, and encrypted data keep your business safe.",
    color: "#7c4dff",
  },
  {
    icon: "mdi-chart-bar",
    title: "Analytics & Insights",
    desc: "Make data-driven decisions with real-time analytics, loss run analysis, and customizable reports.",
    color: "#00bcd4",
  },
];

function FeaturesPage() {
  return (
    <>
      <NavLight />

      <header
        className="py-4 text-white"
        style={{
          background: "linear-gradient(90deg,#0d6efd 0%, #6f42c1 100%)",
        }}
      >
        <div className="container text-center">
          <h1 className="display-5 fw-bold mb-2">
            <i className="mdi mdi-star-circle-outline me-2"></i>
            Why Choose OrderRun
          </h1>
          <p className="lead text-white-75 mb-4">
            All the tools your sportswear business needs — quotes, production,
            inventory and analytics — in one beautiful, fast platform.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <a
              href="/pricing"
              className="btn btn-light btn-lg rounded-pill shadow-sm"
            >
              See Pricing
            </a>
            <a
              href="/contact-us"
              className="btn btn-outline-light text-white-hover btn-lg rounded-pill"
            >
              Contact Sales
            </a>
          </div>
        </div>
      </header>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            {features.map((feature) => (
              <div
                className="col-12 col-sm-6 col-lg-4 d-flex align-items-stretch"
                key={feature.title}
              >
                <div className="card border-0 shadow-sm w-100 h-100 feature-card animate-on-scroll">
                  <div className="card-body d-flex flex-column text-center">
                    <div
                      className="mx-auto d-flex align-items-center justify-content-center mb-3 feature-icon"
                      style={{
                        width: 84,
                        height: 84,
                        borderRadius: 18,
                        background: feature.color + "22",
                        padding: 12,
                      }}
                    >
                      <i
                        className={`mdi ${feature.icon}`}
                        style={{ color: feature.color, fontSize: 28 }}
                      ></i>
                    </div>
                    <h5 className="fw-bold mb-2">{feature.title}</h5>
                    <p className="text-muted mb-4">{feature.desc}</p>
                    {/* <div className="mt-auto">
                      <a
                        href="/contact-us"
                        className="btn btn-sm btn-primary rounded-pill"
                      >
                        Learn more
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row mt-5">
            <div className="col-12 text-center">
              <div className="p-4 rounded-4 shadow-sm bg-white">
                <h4 className="fw-bold mb-2">
                  Ready to streamline your operations?
                </h4>
                <p className="text-muted mb-3">
                  Start a free trial or schedule a demo to see how Sportswear
                  ERP fits your workflow.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <a href="/signup" className="btn btn-primary rounded-pill">
                    Start Free Trial
                  </a>
                  <a
                    href="/contact-us"
                    className="btn btn-outline-primary rounded-pill"
                  >
                    Request Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        .feature-card { transition: transform 0.35s ease, box-shadow 0.35s ease; border-radius: 1rem; }
        .feature-card:hover { transform: translateY(-10px); box-shadow: 0 12px 40px rgba(2,6,23,0.08); }
        .feature-icon { box-shadow: 0 6px 18px rgba(15,23,36,0.06); }
        header p { opacity: .95 }
        .btn-outline-primary { border: 1px solid rgba(13,110,253,0.12); }
        @media (max-width: 576px) { .display-5 { font-size: 1.8rem; } }
      `}</style>
    </>
  );
}

export default FeaturesPage;
